import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';
import { IMyOptions, IMyDate } from 'mydatepicker-th';
import { IMyDpOptions } from 'mydatepicker';

@Component({
  selector: 'app-datepicker',
  templateUrl: './datepicker.component.html',
  styleUrls: ['./datepicker.component.scss']
})

@Pipe({
  name: 'pickDateFormat'
})
export class DatepickerComponent implements OnInit, PipeTransform {

  @Input()
  defaultPlaceholder: string

  @Input()
  requireSelDate: boolean = false

  @Output()
  pickDate: EventEmitter<String> = new EventEmitter<String>();
  dateFormatted: string
  myDatePickerOption: IMyOptions = {
    dateFormat: 'dd/mm/yyyy',
    inline: false,
    height: '54px',
    disableSince: { year: new Date().getFullYear(), month: new Date().getMonth() + 1, day: new Date().getDate() + 1 },
    openSelectorOnInputClick: true,
    editableDateField: false,
    selectionTxtFontSize: "16px",
  }

  // @Output()
  myDatePickerOptions: IMyDpOptions = {
    // other options...
    dateFormat: 'dd/mm/yyyy',
    inline: false,
    height: '54px',
    disableSince: { year: new Date().getFullYear(), month: new Date().getMonth() + 1, day: new Date().getDate() + 1 },
    openSelectorOnInputClick: true,
    editableDateField: false,
    selectionTxtFontSize: "16px",
  };

  selDate: IMyDate


  flag: any

  constructor() { }

  ngOnInit() {
    this.flag = localStorage.getItem("language_flag")

    if (this.requireSelDate === true) {
      let d: Date = new Date()
      this.selDate = {
        year: d.getFullYear(),
        month: d.getMonth() + 1,
        day: d.getDate()
      }
    }
  }

  transform(value: string) {
    let datePipe = new DatePipe("en-US");
    value = datePipe.transform(value, 'dd/MM/yyyy')
    return value
  }

  onDateChanged(event) {
    this.dateFormatted = this.transform(event.jsdate)
    this.pickDate.emit(this.dateFormatted)
  }

}